import { gql } from '@apollo/client';

const schema = {
  current: {
    name: 'shopType',
    serviceName: 'graphql',
    query: gql`
      query shopType($ids: [String]) {
        shopType(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
